import { Environment } from '@portal/core/utils';

export const environment: Environment = {
    production: false,
    stage: true,
    development: false,
    apiUrl: '/api',
    schedulerLicenseKey: 'MDcwMTA1MzMyMy1mY3MtMTc2Mzg2MDQ1Mw==',
};
